var map = {
	"./atmosfera.png": 1117,
	"./banner_kook.png": 974,
	"./banner_ramen_2.png": 976,
	"./clean.png": 1118,
	"./dish.png": 1119,
	"./floctori-banner.png": 1120,
	"./interier.png": 1121,
	"./review-gift.png": 1122,
	"./service.png": 1123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1116;